// export const AddAdmin_REQUEST = "AddAdmin_REQUEST";
// export const AddAdmin_SUCCESS = "AddAdmin_SUCCESS";
// export const AddAdmin_FAIL = "AddAdmin_FAIL";

// export const GetAllAdmins_REQUEST = "GetAllAdmins_REQUEST";
// export const GetAllAdmins_SUCCESS = "GetAllAdmins_SUCCESS";
// export const GetAllAdmins_FAIL = "GetAllAdmins_FAIL";


// AdminConstants.js
export const AddAdmin_REQUEST = "AddAdmin_REQUEST";
export const AddAdmin_SUCCESS = "AddAdmin_SUCCESS";
export const AddAdmin_FAIL = "AddAdmin_FAIL";

export const GetAllAdmins_REQUEST = "GetAllAdmins_REQUEST";
export const GetAllAdmins_SUCCESS = "GetAllAdmins_SUCCESS";
export const GetAllAdmins_FAIL = "GetAllAdmins_FAIL";